import { FC, useEffect } from 'react';

import { Tag } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import OktaSignIn from '@okta/okta-signin-widget';

import { environment } from '../../api';
import { AUTH_STORE_TOKEN } from '../../auth';
import { OktaStore } from '../stores/okta.store';

import '../assets/login-page.css';

export const LoginPage: FC = () => {
    const [oktaStore] = useDependencies(AUTH_STORE_TOKEN) as [OktaStore];

    useEffect(() => {
        const widget = new OktaSignIn(oktaStore.oktaSignInConfig);
        widget
            .showSignInToGetTokens({
                el: '#okta-signin-container',
            })
            .then(tokens => {
                oktaStore.setTokens(tokens);
            });

        return () => {
            widget.remove();
        };
    }, [oktaStore]);

    return (
        <div className="signin-container">
            <div id="okta-signin-container">
                {environment.site.environmentName && (
                    <Tag color="warning">{environment.site.environmentName}</Tag>
                )}
            </div>
            <div className="signin-carousel" />
        </div>
    );
};
LoginPage.displayName = 'LoginPage';
